/* Digital Future Europe — theme.js
   Progressive enhancement only: every feature below has a working
   no-JS fallback (links, native forms, <details>). */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {} };
  var routes = theme.routes || {};
  var strings = theme.strings || {};

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }
  function announce(msg) {
    var region = qs('#GlobalLiveRegion');
    if (!region) return;
    region.textContent = '';
    setTimeout(function () { region.textContent = msg; }, 50);
  }
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  function trapFocus(container, event) {
    var items = qsa(FOCUSABLE, container).filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }

  /* ------------------------------------------------------------------
     Mobile menu drawer (<details>) — Escape, outside click, focus trap
     ------------------------------------------------------------------ */
  function initMenuDrawer() {
    qsa('[data-menu-drawer]').forEach(function (drawer) {
      var summary = qs('summary', drawer);
      var panel = qs('.menu-drawer__panel', drawer);
      function close(returnFocus) {
        if (!drawer.open) return;
        drawer.open = false;
        if (returnFocus) summary.focus();
      }
      drawer.addEventListener('toggle', function () {
        summary.setAttribute('aria-expanded', drawer.open ? 'true' : 'false');
        summary.setAttribute('aria-label', drawer.open ? strings.menuClose : strings.menuOpen);
        document.body.classList.toggle('menu-is-open', drawer.open);
        if (drawer.open) {
          var first = qs(FOCUSABLE, panel);
          if (first) setTimeout(function () { first.focus(); }, 30);
        }
      });
      summary.setAttribute('aria-expanded', 'false');
      summary.setAttribute('aria-controls', panel.id);
      drawer.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { close(true); }
        if (e.key === 'Tab' && drawer.open) trapFocus(drawer, e);
      });
      document.addEventListener('click', function (e) {
        if (drawer.open && !drawer.contains(e.target)) close(false);
      });
      window.addEventListener('resize', debounce(function () {
        if (window.innerWidth >= 990) close(false);
      }, 150));
    });

    /* Desktop dropdowns: close on outside click / Escape, one open at a time */
    var dropdowns = qsa('[data-dropdown]');
    dropdowns.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) dropdowns.forEach(function (o) { if (o !== d) o.open = false; });
      });
      d.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && d.open) { d.open = false; qs('summary', d).focus(); }
      });
    });
    document.addEventListener('click', function (e) {
      dropdowns.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; });
    });
  }

  /* ------------------------------------------------------------------
     Search dialog
     ------------------------------------------------------------------ */
  function initSearchModal() {
    var modal = qs('#SearchModal');
    if (!modal || typeof modal.showModal !== 'function') return;
    var opener = null;
    qsa('[data-search-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        opener = btn;
        modal.showModal();
        var input = qs('input[type="search"]', modal);
        if (input) { input.focus(); input.select(); }
      });
    });
    qsa('[data-search-close]', modal).forEach(function (b) {
      b.addEventListener('click', function () { modal.close(); });
    });
    modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });
    modal.addEventListener('close', function () { if (opener) opener.focus(); });
  }

  /* ------------------------------------------------------------------
     Predictive search (Shopify native API, Section Rendering)
     ------------------------------------------------------------------ */
  if (window.customElements && !customElements.get('predictive-search')) {
    customElements.define('predictive-search', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-disabled')) return;
        this.input = qs('input[type="search"]', this);
        this.results = qs('[data-predictive-results]', this);
        this.status = qs('[data-predictive-status]', this);
        this.activeIndex = -1;
        this.abort = null;
        if (!this.input || !this.results || !routes.predictiveSearch) return;
        this.input.addEventListener('input', debounce(this.onInput.bind(this), 280));
        this.input.addEventListener('keydown', this.onKeydown.bind(this));
        this.input.addEventListener('focus', () => { if (this.input.value.trim()) this.open(); });
      }
      onInput() {
        var term = this.input.value.trim();
        if (!term) { this.closeResults(); return; }
        this.fetchResults(term);
      }
      fetchResults(term) {
        if (this.abort) this.abort.abort();
        this.abort = 'AbortController' in window ? new AbortController() : null;
        this.status.textContent = strings.searchLoading || '';
        var url = routes.predictiveSearch +
          '?q=' + encodeURIComponent(term) +
          '&section_id=predictive-search' +
          '&resources[type]=product,collection,page,query,article' +
          '&resources[limit]=6&resources[limit_scope]=each' +
          '&resources[options][fields]=title,product_type,variants.title,vendor,tag';
        fetch(url, this.abort ? { signal: this.abort.signal } : {})
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then((html) => {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var panel = doc.querySelector('.predictive__panel');
            this.results.innerHTML = panel ? panel.outerHTML : '';
            var count = panel ? parseInt(panel.getAttribute('data-predictive-count') || '0', 10) : 0;
            this.status.textContent = count > 0 ? '' : (strings.searchNoResults || '');
            this.activeIndex = -1;
            this.open();
          })
          .catch((err) => {
            if (err && err.name === 'AbortError') return;
            this.results.innerHTML = '<p class="predictive__status">' + (strings.searchError || '') + '</p>';
            this.status.textContent = strings.searchError || '';
          });
      }
      options() { return qsa('[role="option"]', this.results); }
      open() { this.input.setAttribute('aria-expanded', this.results.innerHTML ? 'true' : 'false'); }
      closeResults() {
        this.results.innerHTML = '';
        this.input.setAttribute('aria-expanded', 'false');
        this.input.removeAttribute('aria-activedescendant');
        this.activeIndex = -1;
      }
      onKeydown(e) {
        var opts = this.options();
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          if (!opts.length) return;
          e.preventDefault();
          var dir = e.key === 'ArrowDown' ? 1 : -1;
          this.activeIndex = (this.activeIndex + dir + opts.length) % opts.length;
          opts.forEach(function (o, i) { o.setAttribute('aria-selected', i === this.activeIndex ? 'true' : 'false'); }, this);
          var active = opts[this.activeIndex];
          this.input.setAttribute('aria-activedescendant', active.id);
          active.scrollIntoView({ block: 'nearest' });
        } else if (e.key === 'Enter' && this.activeIndex > -1 && opts[this.activeIndex]) {
          var link = qs('a', opts[this.activeIndex]);
          if (link) { e.preventDefault(); window.location.href = link.href; }
        } else if (e.key === 'Escape' && this.results.innerHTML) {
          e.stopPropagation();
          e.preventDefault();
          this.closeResults();
        }
      }
    });
  }

  /* ------------------------------------------------------------------
     Auto-submit selects (sort, country)
     ------------------------------------------------------------------ */
  function cleanEmptyFields(form) {
    qsa('input', form).forEach(function (input) {
      if ((input.type === 'number' || input.type === 'text') && input.value === '') input.disabled = true;
    });
  }
  function initAutoSubmit() {
    qsa('[data-auto-submit]').forEach(function (el) {
      el.addEventListener('change', function () {
        var form = el.form;
        if (!form) return;
        if (form.hasAttribute('data-facets-form')) cleanEmptyFields(form);
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    });
  }

  /* ------------------------------------------------------------------
     Facets (filters): desktop auto-apply, mobile drawer with Apply
     ------------------------------------------------------------------ */
  function initFacets() {
    qsa('[data-facets-form]').forEach(function (form) {
      var drawer = qs('[data-facets-drawer]', form);
      var openBtn = qs('[data-facets-open]', form);
      var isDesktop = function () { return window.matchMedia('(min-width: 990px)').matches; };

      form.addEventListener('submit', function () { cleanEmptyFields(form); });

      form.addEventListener('change', function (e) {
        if (e.target.matches('[data-auto-submit]')) return;
        if (!drawer || !drawer.contains(e.target)) return;
        if (isDesktop()) {
          if (e.target.type === 'number') return; /* price: wait for Enter/blur */
          cleanEmptyFields(form);
          form.submit();
        }
      });
      qsa('input[type="number"]', form).forEach(function (input) {
        input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); cleanEmptyFields(form); form.submit(); }
        });
        input.addEventListener('blur', function () {
          if (isDesktop() && input.value !== input.defaultValue) { cleanEmptyFields(form); form.submit(); }
        });
      });

      if (!drawer || !openBtn) return;
      var panel = qs('.facets__panel', drawer);
      function open() {
        drawer.classList.add('is-open');
        openBtn.setAttribute('aria-expanded', 'true');
        drawer.setAttribute('role', 'dialog');
        drawer.setAttribute('aria-modal', 'true');
        document.body.style.overflow = 'hidden';
        setTimeout(function () { panel.focus(); }, 50);
      }
      function close() {
        drawer.classList.remove('is-open');
        openBtn.setAttribute('aria-expanded', 'false');
        drawer.removeAttribute('role');
        drawer.removeAttribute('aria-modal');
        document.body.style.overflow = '';
        openBtn.focus();
      }
      openBtn.addEventListener('click', open);
      qsa('[data-facets-close]', drawer).forEach(function (b) { b.addEventListener('click', close); });
      drawer.addEventListener('keydown', function (e) {
        if (!drawer.classList.contains('is-open')) return;
        if (e.key === 'Escape') close();
        if (e.key === 'Tab') trapFocus(panel, e);
      });
      window.addEventListener('resize', debounce(function () {
        if (isDesktop() && drawer.classList.contains('is-open')) close();
      }, 150));
    });
  }

  /* ------------------------------------------------------------------
     Quantity steppers
     ------------------------------------------------------------------ */
  function initQuantity(root) {
    qsa('[data-qty]', root).forEach(function (wrap) {
      if (wrap.dataset.bound) return;
      wrap.dataset.bound = '1';
      var input = qs('input', wrap);
      var min = parseInt(input.min || '0', 10);
      function set(v) {
        v = Math.max(min, isNaN(v) ? min : v);
        if (String(v) === input.value) return;
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      qs('[data-qty-minus]', wrap).addEventListener('click', function () { set(parseInt(input.value, 10) - 1); });
      qs('[data-qty-plus]', wrap).addEventListener('click', function () { set(parseInt(input.value, 10) + 1); });
    });
  }

  /* ------------------------------------------------------------------
     Cart count + notification
     ------------------------------------------------------------------ */
  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 99 ? '99+' : String(count);
      el.classList.toggle('is-empty', count === 0);
    });
    qsa('[data-cart-link]').forEach(function (el) {
      if (strings.cartCountAria) el.setAttribute('aria-label', strings.cartCountAria.replace('__COUNT__', count));
    });
  }
  function refreshCartCount() {
    return fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); return cart; });
  }
  var toastTimer;
  var toastOpener = null;
  function showCartToast(title) {
    var toast = qs('#CartToast');
    if (!toast) return;
    qs('[data-cart-toast-product]', toast).textContent = title || '';
    toast.hidden = false;
    toastOpener = document.activeElement;
    var viewBtn = qs('.cart-toast__actions a', toast);
    if (viewBtn) viewBtn.focus({ preventScroll: true });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideCartToast, 8000);
  }
  function hideCartToast() {
    var toast = qs('#CartToast');
    if (!toast || toast.hidden) return;
    var hadFocus = toast.contains(document.activeElement);
    toast.hidden = true;
    if (hadFocus && toastOpener && document.contains(toastOpener)) toastOpener.focus({ preventScroll: true });
  }
  function initCartToast() {
    var toast = qs('#CartToast');
    if (!toast) return;
    qs('[data-cart-toast-close]', toast).addEventListener('click', hideCartToast);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hideCartToast(); });
    toast.addEventListener('mouseenter', function () { clearTimeout(toastTimer); });
    toast.addEventListener('focusin', function () { clearTimeout(toastTimer); });
  }

  /* ------------------------------------------------------------------
     AJAX add to cart (product page + quick add). Falls back to normal POST.
     ------------------------------------------------------------------ */
  function initProductForms(root) {
    qsa('form[data-product-form]', root).forEach(function (form) {
      if (form.dataset.bound) return;
      form.dataset.bound = '1';
      form.addEventListener('submit', function (e) {
        if (!window.fetch || !routes.cartAdd) return;
        e.preventDefault();
        var btn = qs('[type="submit"]', form);
        var errorBox = qs('[data-form-error]', form);
        if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
        if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }
        btn.classList.add('is-loading');
        btn.setAttribute('aria-disabled', 'true');
        announce(strings.adding || '');
        fetch(routes.cartAdd + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
          .then(function (res) {
            if (!res.ok || res.data.status) {
              var msg = res.data.description || res.data.message || strings.cartError;
              if (errorBox) { errorBox.textContent = msg; errorBox.hidden = false; }
              else announce(msg);
              return;
            }
            var title = res.data.product_title || res.data.title || '';
            if (res.data.variant_title && res.data.product_has_only_default_variant === false) title += ' — ' + res.data.variant_title;
            refreshCartCount().catch(function () {});
            showCartToast(title);
            announce(strings.addedToCart || '');
          })
          .catch(function () {
            if (errorBox) { errorBox.textContent = strings.cartError; errorBox.hidden = false; }
          })
          .finally(function () {
            btn.classList.remove('is-loading');
            btn.removeAttribute('aria-disabled');
          });
      });
    });
  }

  /* ------------------------------------------------------------------
     Product page: gallery + variant picker
     ------------------------------------------------------------------ */
  function showMedia(section, mediaId) {
    var target = qs('[data-media-id="' + mediaId + '"]', section);
    if (!target) return;
    qsa('.gallery__slide', section).forEach(function (s) {
      var active = s === target;
      s.hidden = !active;
      s.classList.toggle('is-active', active);
      if (!active) qsa('video', s).forEach(function (v) { v.pause(); });
    });
    qsa('[data-thumb]', section).forEach(function (t) {
      var active = t.getAttribute('data-thumb') === String(mediaId);
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  function initProductSections() {
    qsa('[data-product-section]').forEach(function (section) {
      var sectionId = section.getAttribute('data-section-id');
      var productUrl = section.getAttribute('data-product-url');

      /* Gallery thumbnails with arrow-key support */
      var thumbs = qsa('[data-thumb]', section);
      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () { showMedia(section, thumb.getAttribute('data-thumb')); });
        thumb.addEventListener('keydown', function (e) {
          var rtl = document.documentElement.dir === 'rtl';
          var next = rtl ? 'ArrowLeft' : 'ArrowRight';
          var prev = rtl ? 'ArrowRight' : 'ArrowLeft';
          var j = null;
          if (e.key === next) j = (i + 1) % thumbs.length;
          if (e.key === prev) j = (i - 1 + thumbs.length) % thumbs.length;
          if (j !== null) { e.preventDefault(); thumbs[j].focus(); thumbs[j].click(); }
        });
      });

      var jsonEl = qs('[data-product-json]', section);
      var picker = qs('[data-variant-picker]', section);
      var select = qs('[data-variant-select]', section);
      if (!jsonEl || !picker || !select) return;
      var data;
      try { data = JSON.parse(jsonEl.textContent); } catch (err) { return; }
      var variants = data.variants || [];
      var fieldsets = qsa('fieldset[data-option-index]', picker);

      function selectedOptions() {
        return fieldsets.map(function (fs) {
          var checked = qs('input:checked', fs);
          return checked ? checked.value : null;
        });
      }
      function findVariant(opts) {
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
      }
      function markAvailability(opts) {
        fieldsets.forEach(function (fs, idx) {
          qsa('input', fs).forEach(function (input) {
            var test = opts.slice();
            test[idx] = input.value;
            var match = variants.find(function (v) {
              return v.available && v.options.every(function (o, i) { return o === test[i]; });
            });
            var label = qs('label[for="' + input.id + '"]', fs);
            if (label) label.classList.toggle('is-unavailable', !match);
          });
          var current = qs('input:checked', fs);
          var valueEl = qs('[data-selected-value]', fs);
          if (current && valueEl) valueEl.textContent = current.value;
        });
      }
      function setButton(variant) {
        var btn = qs('[data-add-button]', section);
        var label = qs('[data-add-label]', section);
        if (!btn || !label) return;
        if (!variant) {
          btn.disabled = true; label.textContent = strings.unavailable;
        } else if (!variant.available) {
          btn.disabled = true; label.textContent = strings.soldOut;
        } else {
          btn.disabled = false; label.textContent = strings.addToCart;
        }
      }
      function refreshFromServer(variant) {
        if (!variant || !productUrl) return;
        var url = productUrl + (productUrl.indexOf('?') > -1 ? '&' : '?') + 'variant=' + variant.id + '&section_id=' + encodeURIComponent(sectionId);
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            ['[data-price]', '[data-inventory]'].forEach(function (sel) {
              var fresh = doc.querySelector(sel);
              var current = qs(sel, section);
              if (fresh && current) current.innerHTML = fresh.innerHTML;
            });
            var freshSku = doc.querySelector('[data-sku-row]');
            var currentSku = qs('[data-sku-row]', section);
            if (freshSku && currentSku) { currentSku.outerHTML = freshSku.outerHTML; }
          })
          .catch(function () {});
      }
      function onChange() {
        var opts = selectedOptions();
        var variant = findVariant(opts);
        markAvailability(opts);
        setButton(variant);
        if (!variant) return;
        select.value = String(variant.id);
        if (variant.featured_media && variant.featured_media.id) showMedia(section, variant.featured_media.id);
        if (window.history && window.history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', u.toString());
        }
        refreshFromServer(variant);
      }
      picker.addEventListener('change', onChange);
      markAvailability(selectedOptions());
    });
  }

  /* ------------------------------------------------------------------
     Cart page: auto-update on quantity change
     ------------------------------------------------------------------ */
  function initCartPage() {
    var page = qs('[data-cart-page]');
    var form = qs('[data-cart-form]');
    if (!page || !form) return;
    var submitUpdate = debounce(function () {
      page.classList.add('is-updating');
      var updateBtn = qs('[data-cart-update]', form);
      if (form.requestSubmit && updateBtn) form.requestSubmit(updateBtn);
      else {
        var hidden = document.createElement('input');
        hidden.type = 'hidden'; hidden.name = 'update'; hidden.value = '1';
        form.appendChild(hidden);
        form.submit();
      }
    }, 700);
    qsa('[data-cart-qty]', form).forEach(function (input) {
      input.addEventListener('change', submitUpdate);
    });
  }

  /* ------------------------------------------------------------------
     Product recommendations (lazy)
     ------------------------------------------------------------------ */
  function initRecommendations() {
    qsa('[data-recommendations]').forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url || el.children.length) return;
      var load = function () {
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('[data-recommendations]');
            if (fresh && fresh.innerHTML.trim()) {
              el.innerHTML = fresh.innerHTML;
              initProductForms(el);
            }
          })
          .catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { io.disconnect(); load(); }
        }, { rootMargin: '0px 0px 400px 0px' });
        io.observe(el);
      } else { load(); }
    });
  }

  /* ------------------------------------------------------------------
     Address forms: preselect country
     ------------------------------------------------------------------ */
  function initAddressCountry() {
    qsa('select[data-default]').forEach(function (sel) {
      var v = sel.getAttribute('data-default');
      if (v) sel.value = v;
    });
  }

  function init() {
    initMenuDrawer();
    initSearchModal();
    initAutoSubmit();
    initFacets();
    initQuantity(document);
    initCartToast();
    initProductForms(document);
    initProductSections();
    initCartPage();
    initRecommendations();
    initAddressCountry();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Theme editor: re-bind when sections are re-rendered */
  document.addEventListener('shopify:section:load', function (e) {
    initQuantity(e.target);
    initProductForms(e.target);
    initProductSections();
    initRecommendations();
    initMenuDrawer();
  });
})();
